import PrismicDOM from 'prismic-dom';

const richTextToHtml = (richText: any, htmlSerializer = () => {}): string => {
  if (!richText) return '';

  return PrismicDOM.RichText.asHtml(richText, () => {}, htmlSerializer);
};

export default richTextToHtml;
